const flatpickerConfig = {
    datepicker: {
        enableTime: false,
        dateFormat: 'Y-m-d H:i:S',
        altFormat: 'n/d/Y',
        altInput: true,
        disableMobile: "true",
        static: true,
        allowInput: true
    },
    datepickerdatatable: {
        enableTime: false,
        dateFormat: 'Y-m-d H:i:S',
        altFormat: 'n/d/Y',
        altInput: true,
        disableMobile: "true",
        allowInput: true
    },
    daterangepicker: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        altFormat: 'n/d/Y',
        altInput: true,
        mode: 'range',
        disableMobile: "true",
        closeOnSelect: false,
        static: true,
        allowInput: true
    },
    datetimepicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S',
        altFormat: 'n/d/Y h:i K',
        altInput: true,
        disableMobile: "true",
        closeOnSelect: false,
        static: true,
        allowInput: true,
        minuteIncrement: 1,
    },
    timepicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        altFormat: 'h:i K',
        altInput: true,
        disableMobile: "true",
        closeOnSelect: false,
        static: true,
        allowInput: true,
        minuteIncrement: 1
    }
};

export default flatpickerConfig;